<kd-document-heading
    [element]="titleElement"
    [index]="1"
></kd-document-heading>

<div class="kd-release-notes slds-tabs_default">
    <ul class="tabs slds-tabs_default__nav" role="tablist">
        <li class="slds-tabs_default__item" [ngClass]="{'slds-is-active': isTab('releaseInfo')}" title="Release Info" role="presentation">
            <a class="slds-tabs_default__link" href="javascript:void(0);" (click)="setTab('releaseInfo')" role="tab" tabindex="0" aria-selected="true" aria-controls="tab-default-1" id="tab-default-1__item">Release Info</a>
        </li>
        <li class="slds-tabs_default__item" [ngClass]="{'slds-is-active': isTab('newFeatures')}" title="New Features" role="presentation" *ngIf="content.new_feature__release_types">
            <a class="slds-tabs_default__link" href="javascript:void(0);" (click)="setTab('newFeatures')" role="tab" tabindex="-1" aria-selected="false" aria-controls="tab-default-2" id="tab-default-2__item">New Features</a>
        </li>
        <li class="slds-tabs_default__item" [ngClass]="{'slds-is-active': isTab('newEnhancements')}" title="New Enhancements" role="presentation" *ngIf="content.enhancement__release_types">
            <a class="slds-tabs_default__link" href="javascript:void(0);" (click)="setTab('newEnhancements')" role="tab" tabindex="-1" aria-selected="false" aria-controls="tab-default-3" id="tab-default-3__item">New Enhancements</a>
        </li>
        <li class="slds-tabs_default__item" [ngClass]="{'slds-is-active': isTab('bugFixes')}" title="Bug Fixes" role="presentation" *ngIf="content.bugsFixed">
            <a class="slds-tabs_default__link" href="javascript:void(0);" (click)="setTab('bugFixes')" role="tab" tabindex="-1" aria-selected="false" aria-controls="tab-default-4" id="tab-default-4__item">Bug Fixes</a>
        </li>
        <li class="slds-tabs_default__item" [ngClass]="{'slds-is-active': isTab('minorChanges')}" title="Minor Changes" role="presentation" *ngIf="content.minorChanges">
            <a class="slds-tabs_default__link" href="javascript:void(0);" (click)="setTab('minorChanges')" role="tab" tabindex="-1" aria-selected="false" aria-controls="tab-default-5" id="tab-default-5__item">Minor Changes</a>
        </li>
        <li class="slds-tabs_default__item" [ngClass]="{'slds-is-active': isTab('newMetadata')}" title="New Metadata" role="presentation" *ngIf="content.newMetadata">
            <a class="slds-tabs_default__link" href="javascript:void(0);" (click)="setTab('newMetadata')" role="tab" tabindex="-1" aria-selected="false" aria-controls="tab-default-6" id="tab-default-6__item">New Metadata</a>
        </li>
        <li class="slds-tabs_default__item" [ngClass]="{'slds-is-active': isTab('hotFixes')}" title="Hotfixes" role="presentation" *ngIf="content.hotFixes">
            <a class="slds-tabs_default__link" href="javascript:void(0);" (click)="setTab('hotFixes')" role="tab" tabindex="-1" aria-selected="false" aria-controls="tab-default-6" id="tab-default-6__item">Hotfixes</a>
        </li>
    </ul>
    <br />
    <div id="tab-default-1" class="slds-tabs_default__content" [ngClass]="isTab('releaseInfo') ? 'slds-show' : 'slds-hide'" role="tabpanel" aria-labelledby="tab-default-1__item">
        <div *ngIf="content.name" class="kd-document-text">
            <div class="field-name" style="margin-top: 0;">{{content.name.label}}</div>
            <div class="field-value">{{content.name.content}}</div>
        </div>
        <div *ngIf="content['releaseDate']">
            <div class="field-name">{{content.releaseDate.label}}</div>
            <div class="field-value">{{content.releaseDate.content}}</div>
        </div>
        <div *ngIf="content['releaseType']">
            <div class="field-name">{{content.releaseType.label}}</div>
            <div class="field-value" [innerHTML]="content.releaseType.content"></div>
        </div>
        <div *ngIf="content['releaseSummary']">
            <div class="field-name">{{content.releaseSummary.label}}</div>
            <div class="field-value kd-document-text" [innerHTML]="content.releaseSummary.content"></div>
        </div>
        <div *ngIf="content['status']">
            <div class="field-name">{{content.status.label}}</div>
            <div class="field-value">{{content.status.content}}</div>
        </div>
    </div>
    <div id="tab-default-2" class="slds-tabs_default__content" [ngClass]="isTab('newFeatures') ? 'slds-show' : 'slds-hide'" role="tabpanel" aria-labelledby="tab-default-2__item">
        <div class="kd-release-notes__document">
            <kd-document
                *ngIf="content.new_feature__release_types"
                [content]="content.new_feature__release_types"
            ></kd-document>
        </div>
    </div>
    <div id="tab-default-3" class="slds-tabs_default__content" [ngClass]="isTab('newEnhancements') ? 'slds-show' : 'slds-hide'" role="tabpanel" aria-labelledby="tab-default-3__item">
        <div class="kd-release-notes__document">
            <kd-document
                *ngIf="content.enhancement__release_types"
                [content]="content.enhancement__release_types"
            ></kd-document>
        </div>
    </div>
    <div id="tab-default-4" class="slds-tabs_default__content" [ngClass]="isTab('bugFixes') ? 'slds-show' : 'slds-hide'" role="tabpanel" aria-labelledby="tab-default-4__item">
        <div *ngIf="content.bugsFixed" class="kd-document-text">
            <div class="field-value" [innerHTML]="content.bugsFixed.content"></div>
        </div>
    </div>
    <div id="tab-default-5" class="slds-tabs_default__content" [ngClass]="isTab('minorChanges') ? 'slds-show' : 'slds-hide'" role="tabpanel" aria-labelledby="tab-default-5__item">
        <div *ngIf="content.minorChanges" class="kd-document-text">
            <div class="field-value" [innerHTML]="content.minorChanges.content"></div>
        </div>
    </div>
    <div id="tab-default-6" class="slds-tabs_default__content" [ngClass]="isTab('newMetadata') ? 'slds-show' : 'slds-hide'" role="tabpanel" aria-labelledby="tab-default-6__item">
        <div *ngIf="content.newMetadata" class="kd-document-text">
            <div class="field-value" [innerHTML]="content.newMetadata.content"></div>
        </div>
    </div>
    <div id="tab-default-6" class="slds-tabs_default__content" [ngClass]="isTab('hotFixes') ? 'slds-show' : 'slds-hide'" role="tabpanel" aria-labelledby="tab-default-6__item">
        <div *ngIf="content.hotFixes" class="kd-document-text">
            <div class="field-value" [innerHTML]="content.hotFixes.content"></div>
        </div>
    </div>
</div>
